import React from 'react'
import classNames from 'classnames'

import LanguageSelector from './components/LanguageSelector'
import { navbarStyles } from './utils/navbarStyles'
import styles from './PublicPageNavbar.module.css'

import { Breakpoint } from 'components/Breakpoint'

export const PublicPageNavbar: React.FC = () => {
  return (
    <header className={styles.wrapper}>
      <nav className={navbarStyles.nav}>
        <div
          className={classNames(
            navbarStyles.navItemsLayout,
            'justify-end h-16 px-4'
          )}
        >
          <Breakpoint show desktop>
            <LanguageSelector />
          </Breakpoint>
          <Breakpoint show phone tablet>
            <LanguageSelector mobile className="max-w-xs" />
          </Breakpoint>
        </div>
      </nav>
    </header>
  )
}
